import { Component, ElementRef, EventEmitter, Input, Output, SimpleChanges, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { PrimeNGConfig } from 'primeng/api';
import { FileRemoveEvent, FileSelectEvent, FileUpload } from 'primeng/fileupload';

@Component({
  selector: 'app-file-upload',
  templateUrl: './file-upload.component.html',
  styleUrl: './file-upload.component.css'
})
export class FileUploadComponent {

  constructor (private config: PrimeNGConfig) {}

  @ViewChild(FileUpload, {static: false}) upload!: FileUpload;
  @ViewChild('folderInput') folderInput!: ElementRef<HTMLInputElement>;  

  @Input() form?: FormGroup
  @Input() control: string = '';
  @Input() disable: boolean = false;

  @Input() label: string = '';
  @Input() multiple: boolean = false;
  @Input() accept: string = 'application/pdf';
  @Input() text: string = 'Trascina qui il file';
  @Input() critical: boolean = false;

  @Output() load = new EventEmitter<File | File[] | null>();

  files: File[] = [];
  file?: File | null;

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.disable = changes['disable']?.currentValue || this.disable;
  }

  choose(event: any, callback: any) {
    callback();
  }

  triggerChoose() {
    this.upload?.choose();
  }

  onUpload(event: FileSelectEvent) {
    if (this.multiple) {
      event.currentFiles.map((file, index) => !this.files.find((itm) => file == itm) ? this.files.push(file) : null);
      this.form?.patchValue({ [this.control]: this.files });
      this.load.emit(this.files);
    } else {
      this.file = event.currentFiles[0];
      this.form?.patchValue({ [this.control]: this.file });
      this.load.emit(this.file);
    }
  }

  onFolderSelected(event: Event): void {

    const input = event.target as HTMLInputElement;
    const newFiles = Array.from(input.files || []);

    if (newFiles.length === 0) return;

    // Aggiungi i file direttamente all'array interno di p-fileUpload
    newFiles.forEach(file => {
      this.upload.files.push(file);
    });
    
    newFiles.map((file, index) => !this.files.find((itm) => file == itm) ? this.files.push(file) : null);
    this.form?.patchValue({ [this.control]: this.files });
    this.load.emit(this.files);    

    // Triggera il change detection di PrimeNG
    this.upload.cd.markForCheck();

    // Reset input per permettere di ricaricare la stessa cartella
    input.value = '';

  }

  onRemoveUpload(event: any, file: File) {    
    if (this.multiple) {
      this.files = this.files.filter((file_caricato) => file != file_caricato);
      this.form?.patchValue({ [this.control]: this.files });
      this.load.emit(this.files);
    } else {
      this.file = null;
      this.form?.patchValue({ [this.control]: null });
      this.load.emit(null);
    }    
  }

  onClearUpload() {      
    this.files = [];
    this.file = null;
    this.form?.patchValue({ [this.control]: null });
    this.load.emit(null);
  }

  clearUpload() {
    this.upload.clear();
    this.files = [];
    this.file = null;
  }

  formatSize(bytes: number) {
    const k = 1024;
    const dm = 3;
    const sizes = this.config.translation.fileSizeTypes || [];
    if (bytes === 0) {
      return `0 ${sizes[0]}`;
    }
    
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    const formattedSize = parseFloat((bytes / Math.pow(k, i)).toFixed(dm));
    
    return `${formattedSize} ${sizes[i]}`;
  }  

}
